import { useContext, useMemo } from "react";
import { EstablishmentContext } from "@/contexts/EstablishmentContext";
import { useTimeSlotsQuery } from "@/hooks/queries/useTimeSlotsQuery";
import { makeServiceTimeCompare } from "@/lib/serviceOrder";

/**
 * Comparateur d'heures pour les listes de l'équipe. Tant qu'aucun créneau ne
 * franchit minuit, il équivaut exactement à `a.localeCompare(b)`.
 * Sans établissement (hors provider), renvoie aussi `localeCompare`.
 */
export function useServiceTimeCompare() {
  const ctx = useContext(EstablishmentContext);
  const { data: slots } = useTimeSlotsQuery(ctx?.establishmentId ?? null);
  return useMemo(() => makeServiceTimeCompare(slots), [slots]);
}

/** Créneaux réguliers de l'établissement courant (pour la détection des services de nuit). */
export function useServiceSlots() {
  const ctx = useContext(EstablishmentContext);
  const { data: slots } = useTimeSlotsQuery(ctx?.establishmentId ?? null);
  return slots;
}
